import { toJS } from "mobx";
import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { View, YStack } from "tamagui";
import { sanitizeForFirestore } from "../../../modules/core/sanitizeForFirestore";
import { Box } from "../../../ui/Box";
import { Button } from "../../../ui/Button";
import { Label } from "../../../ui/Label";
import { EditorForm } from "../../../ui/YooptaEditor";
import { BusinessAdminTitleAndEmojiEdit } from "../ui/BusinessAdminEmojiPicker";
import type { BusinessInfoData } from "./BusinessInfoModel";

export const BusinessInfoAdmin: React.FC<{
  data: BusinessInfoData;
  onSave: (data: BusinessInfoData) => void;
}> = observer((props) => {
  const [formValues, setFormValues] = useState(toJS(props.data));

  return (
    <View>
      <Box gap="$medium">
        <BusinessAdminTitleAndEmojiEdit
          formValues={formValues}
          onChange={(f) =>
            setFormValues((values) => {
              values.emoji = f.emoji ?? null;
              values.title = f.title ?? null;
              return values;
            })
          }
        />

        <YStack gap="$small">
          <Label>Description</Label>
          <View
            paddingHorizontal={23}
            paddingVertical={12}
            borderColor="$divider"
            borderWidth={1}
          >
            <EditorForm
              value={formValues.descriptionYooptaEditor}
              onSave={(data) => {
                setFormValues((values) => {
                  values.descriptionYooptaEditor =
                    sanitizeForFirestore(data) ?? null;
                  return values;
                });
              }}
              id={"description"}
            />
          </View>
        </YStack>
      </Box>
      <Button onPress={() => props.onSave(formValues)}>Save</Button>
    </View>
  );
});
